import { connect } from 'react-redux';

import {
  getFilteredSegments,
  getMyPermissions,
  getSegmentFilterValue,
  getSegmentSideListContainerWidth,
  getSelectedSegment,
} from '../../../reducers/analyticsApp';
import {
  deleteSegment,
  duplicateSegment,
  selectSegment,
  setSegmentFilterValue,
  setSegmentSideListContainerWidth,
  startUpdateSegment,
} from '../../../actions/segment';
import CompoundSideListItems from '../../../components/compound/side/ListItems';
import { staticPermissions } from '../../../constants/authorization';
import docsBookmarks from '../../../constants/docs';

const mapStateToProps = (state) => ({
  items: getFilteredSegments(state),
  searchedItem: getSegmentFilterValue(state),
  selectedItem: getSelectedSegment(state),
  hasPermission: getMyPermissions(state).has(staticPermissions.SEGMENT_MANAGE),
  containerWidth: getSegmentSideListContainerWidth(state),
  scrolTo: docsBookmarks.segments,
});

const mapDispatchToProps = (dispatch, { navigate, tenantId }) => ({
  onSearch: (value) => dispatch(setSegmentFilterValue(value)),
  onPreview: (item) => {
    dispatch(selectSegment(item));
    navigate(`/${tenantId}/segments/execution/${item.id}`);
  },
  onDelete: (item) => {
    dispatch(deleteSegment(item.id));
  },
  onUpdate: (item) => {
    dispatch(startUpdateSegment(item));
    navigate(`/${tenantId}/segments/update/${item.id}`);
  },
  setContainerWidth: (width) => dispatch(setSegmentSideListContainerWidth(width)),
  onDuplicate: (item) => {
    dispatch(duplicateSegment(item));
    navigate(`/${tenantId}/segments/add`);
  },
  showExposureSQLButton: false,
});

export default connect(mapStateToProps, mapDispatchToProps)(CompoundSideListItems);
